export default "__VITE_ASSET__BIvxVbwT__"